import ExternalScriptLoader from 'lib/external-script-loader'

class Facebook extends ExternalScriptLoader {
  scriptUrl = 'https://connect.facebook.net/en_US/sdk.js'
  options = { defer: true }

  init() {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: process.env.FB_APP_ID,
        xfbml: true,
        version: 'v7.0'
      })
    }
  }

  async share(params) {
    try {
      await this.loadScript()
      window.FB.ui({ method: 'share', mobile_iframe: true, ...params })
    } catch (err) {
      // ignore
    }
  }
}

export default new Facebook()
